
<script>
import vue2Dropzone from "vue2-dropzone";
import { vendorService, customerService, promoCodeService, orderService, deliveryZoneService} from "../../../services";
import { required , requiredIf, email} from "vuelidate/lib/validators";
import config from "../../../config";
import Multiselect from "vue-multiselect";
import { error_message, success_message,findArrById } from "../../../Helper/helper";
import DropzonePopup from "../../../components/widgets/dropzone-popup";
import VueGoogleAutocomplete from 'vue-google-autocomplete';
const count = 0;
export default {
    components: { VueGoogleAutocomplete, vueDropzone: vue2Dropzone, DropzonePopup, vendorService, customerService, Multiselect, promoCodeService, orderService, deliveryZoneService},
    data() {
        return {
            checked: true,
            isLoading: false,
            file1: null,
            tmpCategoryImage: "",
            url: null,
            config: config,
            business_type :"Private",
            is_contact : 1,
            timezones: "",
            customer_id: "",
            customer: [],
            customerCount: 0,
            new_user: 1,
            type: "1",
            cust_type: "1",
            customer_email: "",
            shipping_data: [],
            same_address: 1,
            ship_address: "",
            typeform: {
                user_role: "Private",
                user_name: "",
                last_name: "",
                email: "",
                mobile_number: "",
                city: "",
                street: "",
                apartment: "",
                street_no: "",
                postal_code: "",
                parking_place: "1",
                is_elevator: 0,
                address: "",
                name : "",
                hrb : "",
                vat : "",
                person_first_name : "",
                person_last_name : "",
                person_phone : "",
                person_email : "",
                is_contact_person : "1",
                business_user_name: "",
                business_last_name: "",
                business_email: "",
                business_mobile_number: "",
                notes: "",
                customer_id: "",
                is_new_user: "1",
                is_billing_address:"1",
                shipping_first_name:"",
                shipping_last_name:"",
                bill_first_name: "",
                bill_last_name: "",
                bill_phone: "",
                bill_city: "",
                bill_street: "",
                bill_apartment: "",
                bill_street_no: "",
                bill_postal_code: "",
                bill_address: "",
                shipping_address:"",
                customer_type:'2',
            },
            count: 5,
            
        };
    },
    validations: {
        typeform: {
            user_role: {
                required : requiredIf(function(form){
                    return this.new_user == '1';
                }),
            },
            address: {
                required : requiredIf(function(form){
                    return this.shipping_data == 0 && this.shipping_data == '';
                }),
            },
            user_name: {
                required : requiredIf(function(form){
                    return this.business_type == 'Private';
                }),
            },
            customer_id: {
                required : requiredIf(function(form){
                    return this.new_user == '0' && this.business_type != 'Private' && this.business_type != 'Business';
                }),
            },
            last_name: {
                required : requiredIf(function(form){
                    return this.business_type == 'Private';
                }),
            },
            email: {
                required : requiredIf(function(form){
                    return this.business_type == 'Private' && this.new_user == '1';
                }),
                email
            },
            mobile_number: {
                required : requiredIf(function(form){
                    return this.business_type == 'Private';
                }),
            },
            city: {
                required : requiredIf(function(form){
                    return this.shipping_data == 0 && this.shipping_data == '';
                }),
            },
            street: {
                required : requiredIf(function(form){
                    return this.shipping_data == 0 && this.shipping_data == '';
                }),
            },
            street_no: {
                required : requiredIf(function(form){
                    return this.shipping_data == 0 && this.shipping_data == '';
                }),
            }, 
            postal_code: {
                required : requiredIf(function(form){
                    return this.shipping_data == 0 && this.shipping_data == '';
                }),
            },
            business_user_name: {
                required : requiredIf(function(form){
                    return this.business_type == 'Business';
                }),
            },
            business_last_name: {
                required : requiredIf(function(form){
                    return this.business_type == 'Business';
                }),
            },
            business_email: {
               required : requiredIf(function(form){
                    return this.business_type == 'Business';
                }),
                email
            },
            business_mobile_number: {
                required : requiredIf(function(form){
                    return this.business_type == 'Business';
                }),
            },
            name: {
                required : requiredIf(function(form){
                    return this.business_type == 'Business';
                }),
            },
            hrb: {
                required : requiredIf(function(form){
                    return this.business_type == 'Business';
                }),
            },
            vat: {
                required : requiredIf(function(form){
                    return this.business_type == 'Business';
                }),
            },
            person_first_name: {
                required : requiredIf(function(form){
                    return this.business_type == 'Business' && this.is_contact == '1';
                }),
            },
            person_last_name: {
                required : requiredIf(function(form){
                    return this.business_type == 'Business' && this.is_contact == '1';
                }),
            },
            person_phone: {
                required : requiredIf(function(form){
                    return this.business_type == 'Business' && this.is_contact == '1';
                }),
            }, 
            person_email: {
                required : requiredIf(function(form){
                    return this.business_type == 'Business' && this.is_contact == '1';
                }),
                email
            },
            bill_first_name: {
                required : requiredIf(function(form){
                    return this.same_address == 0;
                }),
            },
            bill_last_name: {
                required : requiredIf(function(form){
                    return this.same_address == 0;
                }),
            },
            bill_city: {
                required : requiredIf(function(form){
                    return this.same_address == 0;
                }),
            },
            bill_street: {
                required : requiredIf(function(form){
                    return this.same_address == 0;
                }),
            },
            bill_street_no: {
                required : requiredIf(function(form){
                    return this.same_address == 0;
                }),
            },
            bill_phone: {
                required : requiredIf(function(form){
                    return this.same_address == 0;
                }),
            },
            bill_postal_code: {
                required : requiredIf(function(form){
                    return this.same_address == 0;
                }),
            },
        },
    },
    methods: {
        check: function(e) {
            if(e.target.checked == true){
                this.same_address = 1;
            }else{
               this.same_address = 0; 
            }
        },
        toggleSelected(value) {
            this.customer_email = value.email;
            if(this.customer_email.length > 0){
                orderService.getCustomerByEmail({email: this.customer_email}).then((response) => {
                    this.shipping_data = response.data.result;
                    this.typeform.shipping_address = response.data.result.length;
                    
                    var defaultAddress;
                    defaultAddress = this.shipping_data.filter(ad => ad.is_primary_address  == '1')
                    this.addToShippingData(defaultAddress[0])
                });
            }
            if(value.user_role == "1"){
                this.business_type = "Private";
                this.typeform.customer_type = "2";
            }else{
                this.business_type = "Business";
                this.typeform.customer_type = "1";
            }
            this.onRoleChange();
        },
        clearAllCustomer() {
            this.customer_id = [];
        },
        asyncFindCustomer(query) {
            this.isLoading = true;
            promoCodeService.getCustomer({search: query}).then((response) => {    
                this.customer = response.data.result;
                this.isLoading = false;
                this.typeform.address = "";
            });
        },
        validate(){
            this.$v.typeform.$touch();
            var isValid = !this.$v.typeform.$invalid;
            this.$emit('on-validate', this.typeform, isValid);
            return isValid;
        },
        vatNumber(e){   
            const floating = /^[A-Za-z0-9 ]+$/;
            let char = String.fromCharCode(e.keyCode);
            if (floating.test(char)) return true;
            else e.preventDefault();
        },
        alphabetic(e){   
            const floating = /^[A-Za-z ]+$/;
            let char = String.fromCharCode(e.keyCode);
            if (floating.test(char)) return true;
            else e.preventDefault();
        },
        hrbNumber(e){   
            const floating = /^[A-Za-z0-9-]+$/;
            let char = String.fromCharCode(e.keyCode);
            if (floating.test(char)) return true;
            else e.preventDefault();
        },
        contactNumber(evt) {
            let val1 = evt.target.value;
            if (!(evt.keyCode == 43 || (evt.keyCode >= 48 && evt.keyCode <= 57))) {
                evt.preventDefault();
            }
            let partlen = val1.split("+").length - 1;
            if (evt.keyCode == 43 && partlen > 0) {
                evt.preventDefault();
            } else if (evt.keyCode == 43 && (evt.target.selectionStart !== undefined && evt.target.selectionStart !== 0)) {
                evt.preventDefault();
            }
        },
        onRoleChange(){
            this.business_type = this.typeform.user_role;
            if(this.business_type == 'Private' || this.business_type == '1'){
                this.typeform = {
                    user_role: "Private",
                    user_name: "",
                    last_name: "",
                    email: "",
                    mobile_number: "",
                    city: "",
                    street: "",
                    apartment: "",
                    street_no: "",
                    postal_code: "",
                    address: "",
                    notes:"",
                    parking_place: "1",
                    is_elevator: 0,
                    is_new_user: this.new_user,
                    is_billing_address: "1",
                    shipping_address:"",
                    bill_first_name: "",
                    bill_last_name: "",
                    bill_phone: "",
                    bill_city: "",
                    bill_street: "",
                    bill_apartment: "",
                    bill_street_no: "",
                    bill_postal_code: "",
                    bill_address: "",
                    customer_id: [],
                    customer_type:'2',
                }
                this.typeform.address = "";
                this.$v.typeform.$reset();
                
            }else if(this.business_type == 'Business' || this.business_type == '5'){
                this.typeform = {
                    user_role: "Business",
                    business_user_name: "",
                    business_last_name: "",
                    business_email: "",
                    business_mobile_number: "",
                    city: "",
                    street: "",
                    apartment: "",
                    street_no: "",
                    postal_code: "",
                    address: "",
                    name : "",
                    hrb : "",
                    vat : "",
                    person_first_name : "",
                    person_last_name : "",
                    person_phone : "",
                    person_email : "",
                    is_contact_person : "1",
                    notes:"",
                    is_new_user: this.new_user,
                    is_billing_address: "1",
                    shipping_address:"",
                    bill_first_name: "",
                    bill_last_name: "",
                    bill_phone: "",
                    bill_city: "",
                    bill_street: "",
                    bill_apartment: "",
                    bill_street_no: "",
                    bill_postal_code: "",
                    bill_address: "",
                    customer_id: [],
                    customer_type:'1'
                }
                this.typeform.address = "";
                this.$v.typeform.$reset();
            }
            this.$emit('clicked', 'business type changed');
        },
        onStatusChange(){
            this.is_contact = this.typeform.is_contact_person;
        },
        getLanguage(){
            vendorService.getLanguage()
            .then(response => {
                this.timezones  = response.data.result.timezone;
            });
        },
        onUserChange(){
            this.new_user = this.typeform.is_new_user;
            this.typeform = {
                //user_role: this.business_type,
                city: "",
                street: "",
                apartment: "",
                street_no: "",
                postal_code: "",
                address: "",
                notes:"",
                parking_place: "1",
                is_elevator: 0,
                user_role: "",
                latitude: "",
                longitude: "",
                is_billing_address:"1",
                bill_city: "",
                bill_street: "",
                bill_apartment: "",
                bill_first_name: "",
                bill_last_name: "",
                bill_phone: "",
                bill_street_no: "",
                bill_postal_code: "",
                bill_address: "",
                customer_type:this.business_type == 'Private' ? '2' : '1',
                customer_id: [],
            }
            this.shipping_data = [];
            this.customer_id = [];
            this.$emit('changed', 'user type changed');
        },
        getAddressData: function (addressData, placeResultData, id) {
            this.address = addressData;
            
            this.typeform.address = placeResultData.formatted_address;
            this.typeform.city = addressData.locality;
            this.typeform.state = addressData.administrative_area_level_1;
            this.typeform.country = addressData.country;
            this.typeform.latitude = addressData.latitude;
            this.typeform.longitude = addressData.longitude;
            this.typeform.postal_code = addressData.postal_code;
            this.typeform.street_no = addressData.street_number;
            this.typeform.street = addressData.route;

            this.$emit('getTimeSlot',this.type);
        },
        getBillAddress: function (addressData, placeResultData, id) {
            this.address = addressData;
            this.typeform.bill_address = placeResultData.formatted_address;
            this.typeform.bill_city = addressData.locality;
            this.typeform.bill_latitude = addressData.latitude;
            this.typeform.bill_longitude = addressData.longitude;
            this.typeform.bill_postal_code = addressData.postal_code;
            this.typeform.bill_street_no = addressData.street_number;
            this.typeform.bill_street = addressData.route;
            this.typeform.bill_first_name = addressData.first_name;
            this.typeform.bill_last_name = addressData.last_name;
            this.typeform.bill_phone = addressData.phone;
        },
        checkPostalCode(e) {
            if(this.typeform.postal_code != '' && this.typeform.postal_code != undefined){
                deliveryZoneService.checkPostalCode({ postal_code:this.typeform.postal_code, email:this.customer_email, customer_type: this.business_type,})
                .then(response => {
                    if (response.data.code === 101) {
                    error_message(response.data.message);
                    }
                });
            }
        },
        checkBillPostalCode(e) {
            deliveryZoneService.checkBillPostalCode({ email:this.customer_email, customer_type: this.business_type,bill_postal_code:this.typeform.bill_postal_code})
            .then(response => {
                if (response.data.code === 101) {
                error_message(response.data.message);
                }
            });
        },
        Onclick(event,data){
            this.typeform.address = event.target.value;
            this.typeform.ship_address = "1";
            this.addToShippingData(data)
            this.$emit('getTimeSlot',this.type);
        },
        addToShippingData(data){
            this.typeform.shipping_address = data.id;
            this.typeform.latitude = data.latitude;
            this.typeform.longitude = data.longitude;
            this.typeform.shipping_first_name = data.first_name;
            this.typeform.shipping_last_name = data.last_name;
            this.typeform.address = data.address;
            this.typeform.mobile_number = data.phone;
            this.typeform.is_billing_address = data.is_same_billing_address;
            this.same_address = data.is_same_billing_address;

            if(data.is_same_billing_address == 0 && data.billing_address != null){
                this.typeform.bill_first_name = data.billing_address.first_name;
                this.typeform.bill_last_name = data.billing_address.last_name;
                this.typeform.bill_phone = data.billing_address.phone;
                this.typeform.bill_city = data.billing_address.city;
                this.typeform.bill_street = data.billing_address.street;
                this.typeform.bill_apartment = data.billing_address.floor;
                this.typeform.bill_street_no = data.billing_address.street_no;
                this.typeform.bill_postal_code = data.billing_address.postal_code;
                this.typeform.bill_address = data.billing_address.address;
            }else{
                this.typeform.bill_first_name = "";
                this.typeform.bill_last_name = "";
                this.typeform.bill_phone = "";
                this.typeform.bill_city = "";
                this.typeform.bill_street = "";
                this.typeform.bill_apartment = "";
                this.typeform.bill_street_no = "";
                this.typeform.bill_postal_code = "";
                this.typeform.bill_address = "";
            }
           
        }
    },
};
</script>
<template>
    <form @submit.prevent="addCustomer">
        <div class="card">
            <div class="card-body">
                <p class="card-title-desc"></p>
                <div class="row">
                    <div class="col-sm-6 vendor-status">
                        <b-form-group
                            id="input-group-1"
                            :label="trans.get('__JSON__.Is New User')"
                            label-for="is_new_user"
                        >
                            <label class="switch">
                            <input
                                type="checkbox"
                                id="togBtn"
                                name="is_new_user"
                                v-model="typeform.is_new_user"
                                class="switch-on"
                                true-value="1"
                                false-value="0"
                                @change="onUserChange"
                            />
                            <div class="slider round">
                                <span class="on">{{ trans.get('__JSON__.Yes') }}</span>
                                <span class="off">{{ trans.get('__JSON__.No') }}</span>
                            </div>
                            </label>
                        </b-form-group>
                    </div>
                
                    <div class="col-sm-6" v-if="this.new_user == '0' || this.new_user == ''">
                        <div class="form-group">
                            <multiselect
                                v-model="$v.typeform.customer_id.$model"
                                id="ajax"
                                label="email"
                                track-by="email"
                                :placeholder="trans.get('__JSON__.Customer Search')"
                                open-direction="bottom"
                                :options="customer"
                                :multiple="false"
                                :searchable="true"
                                :loading="isLoading"
                                @search-change="asyncFindCustomer"
                                @select="toggleSelected"
                                :class="{ 'is-invalid': $v.typeform.customer_id.$error}"
                                >
                                <template slot="tag" slot-scope="{ option, remove }">
                                <span class="custom__tag">
                                    <span>{{ option.email }})</span>
                                    <span class="custom__remove" @click="remove(option)">❌</span>
                                </span>
                                </template>
                                <template slot="clear" slot-scope="props">
                                    <div
                                        class="multiselect__clear"
                                        v-if="customer_id.length"
                                        @mousedown.prevent.stop="clearAll(props.search)"
                                    ></div>
                                </template>
                                <span
                                slot="noResult"
                                >{{ trans.get('__JSON__.Customer not found') }}.</span>
                            </multiselect>
                            <div v-if="$v.typeform.customer_id.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.customer_id.required" >{{ trans.get( "__JSON__.Please choose at least one customer")}}.</span>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Register Customer Search End -->

        <!-- Business Type Info Start -->
        <div class="card" v-if="this.new_user == '1'">
            <div class="card-body">
                <h4 class="card-title">{{ trans.get('__JSON__.Business Type Info') }}</h4>
                <p class="card-title-desc"></p>
                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group" v-if="$auth.setting">
                            <select
                                name="user_role"
                                class="custom-select"
                                id="user_role"
                                v-model="$v.typeform.user_role.$model"
                                :class="{ 'is-invalid':$v.typeform.user_role.$error }"
                                @change="onRoleChange()"
                            >
                                <option value="">{{ trans.get('__JSON__.Select Section Design Type') }}</option>
                                <option value="Private" selected>Private</option>
                                <option value="Business">Business</option>
                            </select>
                            <div v-if="$v.typeform.user_role.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.user_role.required">{{ trans.get('__JSON__.Please select business type') }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Business Type Info End -->

        <!-- Private Start -->
        <div class="card" v-if="this.business_type == 'Private' && this.new_user == '1'">
            <div class="card-body">
                <h4 class="card-title">{{ trans.get('__JSON__.Private Customer') }}</h4>
                <p class="card-title-desc"></p>
                
                <div class="row">
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.First Name')}}</label>
                            <input
                                id="user_name"
                                v-model="$v.typeform.user_name.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.First Name')"
                                name="user_name"
                                :class="{ 'is-invalid': $v.typeform.user_name.$error }"
                            />
                            <div v-if="$v.typeform.user_name.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.user_name.required">{{ trans.get('__JSON__.Please enter first name') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Last Name')}}</label>
                            <input
                                id="last_name"
                                v-model="$v.typeform.last_name.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Last Name')"
                                name="last_name"
                                :class="{ 'is-invalid': $v.typeform.last_name.$error }"
                            />
                            <div v-if="$v.typeform.last_name.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.last_name.required">{{ trans.get('__JSON__.Please enter last name') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Email')}}</label>
                            <input
                                id="email"
                                v-model="$v.typeform.email.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Email')"
                                name="email"
                                :class="{ 'is-invalid': $v.typeform.email.$error }"
                            />
                            <div v-if="$v.typeform.email.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.email.required">{{ trans.get('__JSON__.Please enter email') }}</span>
                                <span v-if="!$v.typeform.email.email" v-cloak>{{ trans.get('__JSON__.This value should be a valid email') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Phone')}}</label>
                            <input
                                maxlength="12"
                                minlength="9"
                                id="mobile_number"
                                v-model="$v.typeform.mobile_number.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Phone')"
                                name="mobile_number"
                                @keypress="contactNumber($event)"
                                :class="{ 'is-invalid': $v.typeform.mobile_number.$error }"
                            />
                            <div v-if="$v.typeform.mobile_number.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.mobile_number.required">{{ trans.get('__JSON__.Please enter contact number') }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Private End -->

        <!-- Business Start -->
        <div class="card" v-if="this.business_type == 'Business' && this.new_user == '1'">
            <div class="card-body">
                <h4 class="card-title">{{ trans.get('__JSON__.Company Details') }}</h4>
                <p class="card-title-desc"></p>
                
                <div class="row">
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Company Name')}}</label>
                            <input
                                id="name"
                                v-model="$v.typeform.name.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Company Name')"
                                name="name"
                                :class="{ 'is-invalid': $v.typeform.name.$error }"
                            />
                            <div v-if="$v.typeform.name.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.name.required">{{ trans.get('__JSON__.Please enter company name') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.CEO First Name')}}</label>
                            <input
                                id="business_user_name"
                                v-model="$v.typeform.business_user_name.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.CEO First Name')"
                                name="business_user_name"
                                :class="{ 'is-invalid': $v.typeform.business_user_name.$error }"
                            />
                            <div v-if="$v.typeform.business_user_name.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.business_user_name.required">{{ trans.get('__JSON__.Please enter ceo first name') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.CEO Last Name')}}</label>
                            <input
                                id="business_last_name"
                                v-model="$v.typeform.business_last_name.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.CEO Last Name')"
                                name="business_last_name"
                                :class="{ 'is-invalid': $v.typeform.business_last_name.$error }"
                            />
                            <div v-if="$v.typeform.business_last_name.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.business_last_name.required">{{ trans.get('__JSON__.Please enter ceo last name') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Email')}}</label>
                            <input
                                id="business_email"
                                v-model="$v.typeform.business_email.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Email')"
                                name="business_email"
                                :class="{ 'is-invalid': $v.typeform.business_email.$error }"
                            />
                            <div v-if="$v.typeform.business_email.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.business_email.required">{{ trans.get('__JSON__.Please enter email') }}</span>
                                <span v-if="!$v.typeform.business_email.email" v-cloak>{{ trans.get('__JSON__.This value should be a valid email') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.HRB')}}</label>
                            <input
                                minlength="5"
                                id="hrb"
                                v-model="$v.typeform.hrb.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.HRB')"
                                name="hrb"
                                v-on:keypress="hrbNumber($event,typeform.hrb)"
                                :class="{ 'is-invalid': $v.typeform.hrb.$error }"
                            />
                            <div v-if="$v.typeform.hrb.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.hrb.required">{{ trans.get('__JSON__.Please enter hrb') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Vat')}}</label>
                            <div class="input-group mb-2">
                                <div class="input-group-prepend">
                                    <div class="input-group-text h-100 cust-input">DE</div>
                                </div>
                                <input
                                    maxlength="13"
                                    id="vat"
                                    v-model="$v.typeform.vat.$model"
                                    type="text"
                                    class="form-control"
                                    :placeholder="trans.trans('__JSON__.Vat')"
                                    name="vat"
                                    v-on:keypress="vatNumber($event,typeform.vat)"
                                    :class="{ 'is-invalid': $v.typeform.vat.$error }"
                                />
                            </div>
                            <div v-if="$v.typeform.vat.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.vat.required">{{ trans.get('__JSON__.Please enter vat') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Phone')}}</label>
                            <input
                                maxlength="12"
                                minlength="9"
                                id="business_mobile_number"
                                v-model="$v.typeform.business_mobile_number.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Phone')"
                                name="business_mobile_number"
                                @keypress="contactNumber($event)"
                                :class="{ 'is-invalid': $v.typeform.business_mobile_number.$error }"
                            />
                            <div v-if="$v.typeform.business_mobile_number.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.business_mobile_number.required">{{ trans.get('__JSON__.Please enter contact number') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <b-form-group id="input-group-2" :label="trans.get('__JSON__.Is Contact Person')" label-for="Is Contact Person" >
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="swtich-data">
                                        <label class="switch">
                                        <input
                                            type="checkbox"
                                            id="togBtn"
                                            class="switch-on"
                                            name="is_contact_person"
                                            v-model="typeform.is_contact_person"
                                            true-value="1"
                                            false-value="0"
                                            @change="onStatusChange"
                                        />
                                        <div class="slider round">
                                            <!--ADDED HTML -->
                                            <span class="on">{{ trans.get('__JSON__.Yes') }}</span>
                                            <span class="off">{{ trans.get('__JSON__.No') }}</span>
                                            <!--END-->
                                        </div>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </b-form-group>
                    </div>

                </div>
            </div>
        </div>
        <!-- Business End -->

        <!-- Compant Start -->
        <div class="card" v-if="this.business_type == 'Business' && this.is_contact == 1 && this.new_user == '1'">
            <div class="card-body">
                <h4 class="card-title">{{ trans.get('__JSON__.Contact Person') }}</h4>
                <p class="card-title-desc"></p>
                
                <div class="row">

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.First Name')}}</label>
                            <input
                                id="person_first_name"
                                v-model="$v.typeform.person_first_name.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.First Name')"
                                name="person_first_name"
                                :class="{ 'is-invalid': $v.typeform.person_first_name.$error }"
                            />
                            <div v-if="$v.typeform.person_first_name.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.person_first_name.required">{{ trans.get('__JSON__.Please enter first name') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Last Name')}}</label>
                            <input
                                id="person_last_name"
                                v-model="$v.typeform.person_last_name.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Last Name')"
                                name="person_last_name"
                                :class="{ 'is-invalid': $v.typeform.person_last_name.$error }"
                            />
                            <div v-if="$v.typeform.person_last_name.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.person_last_name.required">{{ trans.get('__JSON__.Please enter last name') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Phone')}}</label>
                            <input
                                maxlength="12"
                                minlength="9"
                                id="person_phone"
                                v-model="$v.typeform.person_phone.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Phone')"
                                name="person_phone"
                                @keypress="contactNumber($event)"
                                :class="{ 'is-invalid': $v.typeform.person_phone.$error }"
                            />
                            <div v-if="$v.typeform.person_phone.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.person_phone.required">{{ trans.get('__JSON__.Please enter contact number') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Email')}}</label>
                            <input
                                id="person_email"
                                v-model="$v.typeform.person_email.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Email')"
                                name="person_email"
                                :class="{ 'is-invalid': $v.typeform.person_email.$error }"
                            />
                            <div v-if="$v.typeform.person_email.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.person_email.required">{{ trans.get('__JSON__.Please enter email') }}</span>
                                <span v-if="!$v.typeform.person_email.email" v-cloak>{{ trans.get('__JSON__.This value should be a valid email') }}</span>
                            </div>
                        </div>
                    </div> 
                </div>
            </div>
        </div>
        <!-- Business End -->

        <!-- Address Start -->
        <div class="card">
            <div class="card-body">
                <h4 class="card-title">{{ trans.get('__JSON__.Address') }}</h4>
                <p class="card-title-desc"></p>
                <div class="row" v-if="this.shipping_data.length > 0 && this.new_user == '0'">
                    <div class="col-sm-6">
                        <div class="form-group">
                            <div v-for="(v,i) in shipping_data" :key="i">
                                <div class="form-check mb-3">
                                    <input class="form-check-input" type="radio" name="address_radio" id="address_radio" v-bind:value="v.id" :checked="v.is_primary_address == 1" @change="Onclick($event,v)"/>
                                    <label class="form-check-label" for="address_radio">{{v.first_name}} {{v.last_name}} - {{v.address}}, {{v.postal_code}}</label>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="this.shipping_data.length == 0 && this.shipping_data.length == ''">
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="control-label required">{{ trans.get('__JSON__.Full address') }}</label>
                            <vue-google-autocomplete
                                ref="address"
                                id="addres"
                                v-model="$v.typeform.address.$model"
                                name="address"
                                type="text"
                                class="form-control"
                                placeholder="Please type your address"
                                v-on:placechanged="getAddressData"
                                :class="{'is-invalid':$v.typeform.address.$error}"
                            >
                            </vue-google-autocomplete>
                            <div v-if="$v.typeform.address.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.address.required">{{ trans.get('__JSON__.Please enter address') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label>{{ trans.trans('__JSON__.Floor')}}</label>
                            <input
                                maxlength="2"
                                minlength="1"
                                id="apartment"
                                v-model="typeform.apartment"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Floor')"
                                name="apartment"
                                @keypress="contactNumber($event)"
                            />
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Street')}}</label>
                            <input
                                id="street"
                                v-model="$v.typeform.street.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Street')"
                                name="street"
                                v-on:keypress="alphabetic($event,typeform.street)"
                                :class="{ 'is-invalid': $v.typeform.street.$error }"
                            />
                            <div v-if="$v.typeform.street.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.street.required">{{ trans.get('__JSON__.Please enter street name') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Street Number')}}</label>
                            <input
                                maxlength="11"
                                minlength="1"
                                id="street_no"
                                v-model="$v.typeform.street_no.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Street Number')"
                             
                                name="street_no"
                                :class="{ 'is-invalid': $v.typeform.street_no.$error }"
                            /> 
                            <!--    @keypress="contactNumber($event)" -->
                            <div v-if="$v.typeform.street_no.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.street_no.required">{{ trans.get('__JSON__.Please enter street number') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Postal Code')}}</label>
                            <input
                                maxlength="5"
                                minlength="5"
                                id="postal_code"
                                v-model="$v.typeform.postal_code.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Postal Code')"
                                name="postal_code"
                                @blur="checkPostalCode"
                                @keypress="contactNumber($event)"
                                :class="{ 'is-invalid': $v.typeform.postal_code.$error }"
                            />
                            <div v-if="$v.typeform.postal_code.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.postal_code.required">{{ trans.get('__JSON__.Please enter postal code') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.City')}}</label>
                            <input
                                id="city"
                                v-model="$v.typeform.city.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.City')"
                                name="city"
                                :class="{ 'is-invalid': $v.typeform.city.$error }"
                                v-on:keypress="alphabetic($event,typeform.city)"
                            />
                            <div v-if="$v.typeform.city.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.city.required">{{ trans.get('__JSON__.City Name Error') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4 vendor-status">
                        <b-form-group id="input-group-2" :label="trans.get('__JSON__.Parking Place')" label-for="Parking Place" >
                            <div class="row">
                                <div class="col-sm-6">
                                    <select
                                        name="parking_place"
                                        v-on:keypress="alphabetic($event,typeform.parking_place)"
                                        class="custom-select"
                                        id="parking_place"
                                        v-model="typeform.parking_place"
                                    >
                                        <option value="">
                                            {{ trans.get("__JSON__.Select Parking Place") }}
                                        </option>
                                        <option value="1">Frontdoor</option>
                                        <option value="0">Basement</option>
                                    </select>
                                </div>
                            </div>
                        </b-form-group>
                    </div>

                    <div class="col-md-4 vendor-status">
                        <b-form-group id="input-group-2" :label="trans.get('__JSON__.Elevator Available')" label-for="Elevator Available" >
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="swtich-data">
                                        <label class="switch">
                                        <input
                                            type="checkbox"
                                            id="togBtn"
                                            class="switch-on"
                                            name="is_elevator"
                                            v-model="typeform.is_elevator"
                                            true-value="1"
                                            false-value="0"
                                        />
                                        <div class="slider round">
                                            <span class="on">{{ trans.get('__JSON__.Yes') }}</span>
                                            <span class="off">{{ trans.get('__JSON__.No') }}</span>
                                        </div>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </b-form-group>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label>{{ trans.trans('__JSON__.Message From Customer')}}</label>
                            <textarea
                                rows="5"
                                id="notes"
                                v-model="typeform.notes"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Message From Customer')"
                                name="notes"
                            ></textarea>
                        </div>
                    </div>
                </div>
                <div class="d-flex align-items-center gap-2">
                    <input 
                        type="checkbox" 
                        id="checkbox" 
                        v-model="typeform.is_billing_address" 
                        :checked="this.typeform.is_billing_address == 1" 
                        @click="check($event)" 
                        true-value="1"
                        false-value="0">
                    <label for="checkbox" class="mb-0"> Billing address is same as shipping address</label>
                </div>
            </div>
        </div>
        <!-- Address End -->

        <!-- Billing Address Start -->
        <div class="card" v-if="this.same_address == 0 && this.typeform.is_billing_address == 0">
            <div class="card-body">
                <h4 class="card-title">{{ trans.get('__JSON__.Billing Address') }}</h4>
                <p class="card-title-desc"></p>
                <div class="row">

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.First Name')}}</label>
                            <input
                                id="bill_first_name"
                                v-model="$v.typeform.bill_first_name.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.First Name')"
                                name="bill_first_name"
                                :class="{ 'is-invalid': $v.typeform.bill_first_name.$error }"
                            />
                            
                            <div v-if="$v.typeform.bill_first_name.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.bill_first_name.required">{{ trans.get('__JSON__.Please enter first name') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Last Name')}}</label>
                            <input
                                id="bill_last_name"
                                v-model="$v.typeform.bill_last_name.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Last Name')"
                                name="bill_last_name"
                                :class="{ 'is-invalid': $v.typeform.bill_last_name.$error }"
                            />
                            <div v-if="$v.typeform.bill_last_name.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.bill_last_name.required">{{ trans.get('__JSON__.Please enter last name') }}</span>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="col-sm-4">
                        <div class="form-group">
                            <label class="control-label required">{{ trans.get('__JSON__.Full address') }}</label>
                            <vue-google-autocomplete
                                ref="bill_address"
                                id="bill_address"
                                v-model="$v.typeform.bill_address.$model"
                                name="bill_address"
                                type="text"
                                class="form-control"
                                placeholder="Please type your address"
                                v-on:placechanged="getBillAddress"
                                :class="{'is-invalid':$v.typeform.bill_address.$error}"
                            >
                            </vue-google-autocomplete>
                            <div v-if="$v.typeform.bill_address.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.bill_address.required">{{ trans.get('__JSON__.Please enter address') }}</span>
                            </div>
                        </div>
                    </div> -->

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label>{{ trans.trans('__JSON__.Floor')}}</label>
                            <input
                                maxlength="2"
                                minlength="1"
                                id="bill_apartment"
                                v-model="typeform.bill_apartment"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Floor')"
                                name="bill_apartment"
                                @keypress="contactNumber($event)"
                            />
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Street')}}</label>
                            <input
                                id="bill_street"
                                v-model="$v.typeform.bill_street.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Street')"
                                name="bill_street"
                                v-on:keypress="alphabetic($event,typeform.bill_street)"
                                :class="{ 'is-invalid': $v.typeform.bill_street.$error }"
                            />
                            <div v-if="$v.typeform.bill_street.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.bill_street.required">{{ trans.get('__JSON__.Please enter street name') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Street Number')}}</label>
                            <input
                                maxlength="11"
                                minlength="1"
                                id="bill_street_no"
                                v-model="$v.typeform.bill_street_no.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Street Number')"
                               
                                name="bill_street_no"
                                :class="{ 'is-invalid': $v.typeform.bill_street_no.$error }"
                            /> 
                            <!--  @keypress="contactNumber($event)" -->
                            <div v-if="$v.typeform.bill_street_no.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.bill_street_no.required">{{ trans.get('__JSON__.Please enter street number') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Postal Code')}}</label>
                            <input
                                maxlength="5"
                                minlength="5"
                                id="bill_postal_code"
                                v-model="$v.typeform.bill_postal_code.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Postal Code')"
                                name="bill_postal_code"
                                @keypress="contactNumber($event)"
                                :class="{ 'is-invalid': $v.typeform.bill_postal_code.$error }"
                            />
                            <div v-if="$v.typeform.bill_postal_code.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.bill_postal_code.required">{{ trans.get('__JSON__.Please enter postal code') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.City')}}</label>
                            <input
                                id="bill_city"
                                v-model="$v.typeform.bill_city.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.City')"
                                name="bill_city"
                                :class="{ 'is-invalid': $v.typeform.bill_city.$error }"
                                v-on:keypress="alphabetic($event,typeform.bill_city)"
                            />
                            <div v-if="$v.typeform.bill_city.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.bill_city.required">{{ trans.get('__JSON__.City Name Error') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Phone')}}</label>
                            <input
                                maxlength="12"
                                minlength="9"
                                id="bill_phone"
                                v-model="$v.typeform.bill_phone.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Phone')"
                                name="mobile_number"
                                @keypress="contactNumber($event)"
                                :class="{ 'is-invalid': $v.typeform.bill_phone.$error }"
                            />
                            <div v-if="$v.typeform.bill_phone.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.bill_phone.required">{{ trans.get('__JSON__.Please enter contact number') }}</span>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <!-- Address End -->
    </form>
</template>